
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const EventsSection = () => {
  const events = [
    {
      date: '3月下旬〜4月上旬',
      title: '大石桜観賞',
      description: '境内の見事なしだれ桜が満開を迎えます。夜間はライトアップも実施。'
    },
    {
      date: '12月14日',
      title: '義士祭',
      description: '討ち入りの日を記念した祭礼。義士装束の行列が神社を目指します。'
    },
    {
      date: '毎月1日・15日',
      title: '月次祭',
      description: '毎月の定例祭。皆様の健康と幸福を祈願いたします。'
    }
  ];

  return (
    <section className="bg-[#0A0A0A] py-24 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-[30%_70%] gap-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-[#D4AF37] font-serif text-5xl font-bold tracking-wide" style={{ writingMode: 'vertical-rl' }}>
              祭礼行事
            </h2>
          </motion.div>

          <div className="space-y-6">
            {events.map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="bg-[#1A1A1A] border-l-4 border-[#D4AF37] p-6 hover:bg-[#222] transition-all group cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <p className="text-white text-2xl font-bold mb-2">{event.date}</p>
                    <h3 className="text-[#D4AF37] text-xl font-semibold mb-2 tracking-wide">{event.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{event.description}</p>
                  </div>
                  <i className="ri-arrow-right-line text-[#D4AF37] text-2xl group-hover:translate-x-2 transition-transform"></i>
                </div>
              </motion.div>
            ))}

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="pt-6"
            >
              <Link 
                to="/festivals"
                className="inline-flex items-center gap-3 px-6 py-3 border border-[#D4AF37] text-white rounded-full hover:bg-[#D4AF37] hover:text-black transition-all group cursor-pointer whitespace-nowrap"
              >
                <span className="tracking-wide">すべての行事を見る</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
